import { alphabeticalSort } from '@cims-online/shared'
import { HelpMessage } from 'utils/constants'
import { useNameColumn } from 'components/CIMSTable/common/hooks/useNameColumn'
import { CIMSColumn } from 'components/CIMSTable/CIMSColumn/types'
import UserTags from 'components/CIMSTags/common/UserTags'
import {
  RoutingGroup,
  useRoutingGroupsTableContext,
} from '../../../RoutingGroupsTableContext'
import { useOptionalDescriptionColumn } from 'components/CIMSTable/common/hooks/useDescriptionColumn'

export const useColumns = (): CIMSColumn<RoutingGroup>[] => {
  const { records } = useRoutingGroupsTableContext()
  return [
    useNameColumn({
      help: HelpMessage.CAS.RoutingGroups.Name,
      sort: { default: 'ascend' },
    }),
    useOptionalDescriptionColumn('Routing Group'),
    {
      title: 'Approvers',
      width: 300,
      help: HelpMessage.CAS.RoutingGroups.Approvers,
      render: ({ users }) => <UserTags users={users} />,
      filter: {
        with: 'callback',
        items: records
          ?.flatMap(({ users }) => users)
          .map(({ id, displayName, mail }) => ({
            text: displayName ?? mail,
            value: id,
          }))
          .sort(alphabeticalSort('text')),
        onFilter: (value, { users }) => users.some(({ id }) => id === value),
      },
    },
  ]
}
